const useUserAgent = () => {
  if (typeof window !== 'undefined') {
    const { userAgent } = window?.navigator;
    const isIOs = /iPad|iPhone|iPod/.test(userAgent);
    const isAndroid = /Android/.test(userAgent);
    // @ts-ignore
    const isSafariDesktop = window?.safari !== undefined;

    const areAppleDevicesPresent = isIOs || isSafariDesktop;
    return {
      areAppleDevicesPresent,
      isAndroid,
      isIOs,
      isSafariDesktop,
    };
  }
  return {
    areAppleDevicesPresent: false,
    isAndroid: false,
    isIOs: false,
    isSafariDesktop: false,
  };
};

export default useUserAgent;
